<mat-sidenav-container class="container">
  <mat-sidenav class="sidenav" mode="side"
               opened [fixedInViewport]="true"
               fixedTopGap="30">
<div class="menu-background">
<button mat-button [matMenuTriggerFor]="aboveMenu">Above</button>
<mat-menu #aboveMenu="matMenu" yPosition="above">
  <button mat-menu-item>Item 1</button>
  <button mat-menu-item>Item 2</button>
</mat-menu>
</div>
  </mat-sidenav>
</mat-sidenav-container>
